import React from 'react';
import { Link } from "react-router-dom";
import navigation from "../../data/navigation.json";
import NavHelper from '../../helper/NavHelper';

class Header extends NavHelper {
    render() {
        const stickyHeader = this.state.stickyHeader ? ' sticky' : '';
        return (
            <header className="header">
                <div className={"navigation-wrapper" + stickyHeader}>
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <nav>
                                    <div className="main-navigation">
                                        <div className="logo"> <Link to="/"> <img src={process.env.PUBLIC_URL + "/assets/images/logo.png"} className="image-fit" alt="logo" /> </Link> </div>
                                        <div className={this.state.navMethod === true ? 'main-menu active' : 'main-menu'}>
                                            <ul className="custom-flex">
                                                {/* Data */}
                                                {navigation.length > 0 ? navigation.map((item, i) => (
                                                    <li key={i} className={`menu-item ${item.child ? 'menu-item-has-children' : ''} `} onClick={this.triggerChild}>
                                                        {item.child ? <Link onClick={e => e.preventDefault()} to="/"> {item.linkText} <span className="arrow" /></Link> : <Link to={item.link}> {item.linkText} </Link>}
                                                        {item.child ?
                                                            <ul className="submenu custom" role="menu">
                                                                {item.submenu.map((sub_item, i) => (
                                                                    <li key={i} className={`menu-item ${sub_item.child ? 'menu-item-has-children' : ''} `}>
                                                                        {sub_item.child ? <Link onClick={e => e.preventDefault()} to="/"> {sub_item.linkText} <span className="arrow" /></Link> : <Link to={sub_item.link}> {sub_item.linkText} </Link>}
                                                                        {sub_item.submenu ?
                                                                            <ul className="submenu custom">
                                                                                {sub_item.submenu.map((third_item, i) => (
                                                                                    <li className="menu-item" key={i}><Link
                                                                                        to={third_item.link}>{third_item.linkText}</Link>
                                                                                    </li>
                                                                                ))}
                                                                            </ul> : null}
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                            : null
                                                        }
                                                    </li>
                                                )) : null}
                                                {/* Data */}
                                                <li className="book-appointment"> <Link to="/booking">Booking Now</Link> </li>
                                            </ul>
                                        </div>
                                        <div className="hamburger-menu" onClick={this.toggleNav}>
                                            <div className={this.state.navMethod === true ? 'menu-btn active' : 'menu-btn'}>
                                                <span />
                                                <span />
                                                <span />
                                            </div>
                                        </div>
                                    </div>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

export default Header;